<template>
  <div>
    <v-menu z-index="10000" bottom offset-y>
      <template v-slot:activator="{ on: onMenu }">
        <v-btn icon v-on="onMenu">
          <v-tooltip bottom>
            <template #activator="{ on: onTooltip }">
              <v-icon :color="iconColor" v-on="{ ...onMenu, ...onTooltip }"
                >fas fa-th-list</v-icon
              >
            </template>
            <span>App switcher</span>
          </v-tooltip>
        </v-btn>
      </template>
      <v-list flat>
        <v-list-item v-for="(item, index) in applications" v-show="item.show" :key="index" :href="item.link" :ripple="false">
          <v-list-item-title>
            <span class="primary--text">{{ $t(item.name) }}</span>
            <v-icon
              class="float-right ml-10"
              size="1em"
              color="primary"
              aria-hidden="true"
              >
                {{ iconClass(item.icon) }}
              </v-icon>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import { reactive, toRefs } from "../../plugins/compositionApi";

export default {
  name: "ApplicationSwitcher",
  props: {
    applications: {
      type: Array
    },
    iconColor: {
      type: String,
      default: "primary"
    }
  },
  setup() {
    const switcher = reactive({});

    function iconClass(icon) {
      return "fa fa-" + icon;
    }
    return { ...toRefs(switcher), iconClass };
  }
};
</script>
